import React from "react";

import ThankYou from "../../components/ThankYou";
export default function ThadvFac() {
  return (
    <div>
      <ThankYou />
    </div>
  );
}
